/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'fill_arrow_white': {
    width: 8,
    height: 9,
    viewBox: '0 0 8 9',
    data: '<defs><path pid="0" id="svgicon-fill_arrow_white-a" d="M0 0h7.193v7.989H0z"/></defs><g transform="translate(.206 .376)" _fill="none" fill-rule="evenodd"><mask id="svgicon-fill_arrow_white-b" _fill="#fff"><use xlink:href="#svgicon-fill_arrow_white-a"/></mask><path pid="1" d="M.004.694S-.033-.27.877.074c.204.078.403.233.591.341.462.266.924.533 1.387.798.718.41 1.435.823 2.152 1.235l1.092.627c.323.185.74.347.98.64.206.25.117.496-.144.665-.388.251-.794.479-1.193.713-1.373.804-2.75 1.599-4.12 2.407-.29.17-.583.343-.904.444-.414.13-.7-.026-.707-.465-.036-1.967.032-3.935.004-5.902L.004.694" _fill="#fff" mask="url(#svgicon-fill_arrow_white-b)"/></g>'
  }
})
